var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-layout',{attrs:{"add-class":"type-b"}},[_c('popup-change-group-delivery',{attrs:{"group-list":_vm.groupList},on:{"dispose":_vm.onDispose,"ok":_vm.onDeliveryList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }